import { inject } from '@angular/core';
import { TeacherApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const teacherTableConfig = (): TableConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    title: 'Danh sách giáo viên',
    entityName: 'giáo viên',
    service: teacherApiService,
    method: 'getTeachers',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text'},
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text'},
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text'},
      { field: 'employeePosition.status', header: 'Tình trạng', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'employeePositionStatus' },
      { field: 'currentMin', header: 'Min', width: 'min-w-[40px]', sortable: true, type: 'text' },
      { field: 'currentMax', header: 'Max', width: 'min-w-[40px]', sortable: true, type: 'text' },
      { field: 'teacherCourseLevels', header: 'Cấp độ', width: 'min-w-[200px]', sortable: false, type: 'custom' },
      { field: 'currentAvailableShifts', header: 'Ca làm việc', width: 'min-w-[150px]', sortable: false, type: 'custom' },
      { field: 'teacherClusters', header: 'Cụm làm việc', width: 'min-w-[150px]', sortable: false, type: 'custom' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'row',
        tooltip: 'Thêm cấp độ',
        icon: 'pi pi-star',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.ADD_LEVEL
      },
      {
        location: 'row',
        tooltip: 'Đổi cụm',
        icon: 'pi pi-sitemap',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.CHANGE_CLUSTER
      },
      {
        location: 'row',
        tooltip: 'Đổi ca',
        icon: 'pi pi-clock',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.CHANGE_SHIFT
      },
      {
        location: 'row',
        tooltip: 'Đổi số lớp',
        icon: 'pi pi-chart-bar',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.CHANGE_MINMAX
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
